import { useTranslation } from 'react-i18next';
import { RUTA_IMATGES } from '../Compartido/contenidoCamprodon.js';

// Fletxes llargues dels sliders del disseny (c-slider-controls); children:
// p.ex. el comptador de fotos.
const ControlesSlider = ({ onPrev, onNext, prevDisabled = false, nextDisabled = false, className = "", children }) => {

    const { t } = useTranslation();

    return (
        <div className={"c-slider-controls d-flex-center " + className}>
            <button type="button" className="c-slider-controls__button c-slider-controls__button--prev d-flex-center" aria-label={t("Anterior")} onClick={onPrev} disabled={prevDisabled}>
                <svg aria-hidden="true" focusable="false" className="c-icon" width="37" height="11">
                    <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-arrow-slider-left"}></use>
                </svg>
            </button>
            <button type="button" className="c-slider-controls__button d-flex-center" aria-label={t("Siguiente")} onClick={onNext} disabled={nextDisabled}>
                <svg aria-hidden="true" focusable="false" className="c-icon" width="37" height="11">
                    <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-arrow-slider-right"}></use>
                </svg>
            </button>
            {children}
        </div>
    );
};

export default ControlesSlider;
